import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LogIn } from 'lucide-react';
import { useAuth } from '../hooks/useAuth';
import { Button } from '../components/Common/Button';
import { Input } from '../components/Common/Input';
import { Label } from '../components/Common/Label';
import { PasswordInput } from '../components/Common/PasswordInput';

const AdminLogin = () => {
  const { login, isAuthenticated, user } = useAuth();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const bgStyle = {
    backgroundImage: `url(${process.env.PUBLIC_URL}/GrosselternMitKindern.png)`,
  };

  // Already authenticated → go to moderation
  if (isAuthenticated) {
    if (user?.role === 'moderator' || user?.role === 'admin') {
      navigate('/moderation', { replace: true });
    } else {
      return (
        <div className="auth-fullpage" style={bgStyle}>
          <div className="auth-fullpage-panel">
            <div className="auth-panel-body">
              <p className="error-message">
                Ihr Konto hat keine Administrator- oder Moderatorenrechte.
              </p>
            </div>
          </div>
        </div>
      );
    }
    return null;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const loggedInUser = await login(formData);
      if (loggedInUser?.role === 'moderator' || loggedInUser?.role === 'admin') {
        navigate('/moderation', { replace: true });
      } else {
        setError('Ihr Konto hat keine Administrator- oder Moderatorenrechte.');
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Anmeldung fehlgeschlagen.');
    } finally {
      setLoading(false);
    }
  };

  const handleButtonClick = () => {
    handleSubmit({ preventDefault: () => {} });
  };

  return (
    <div className="auth-fullpage" style={bgStyle}>
      <div className="auth-fullpage-panel">
        <div className="auth-panel-body">
          <h2 className="ml-success-title" style={{ textAlign: 'left', marginBottom: 'var(--spacing-2)' }}>
            Admin-Anmeldung
          </h2>
          <p className="ml-success-hint" style={{ textAlign: 'left', marginBottom: 'var(--spacing-5)' }}>
            Zugang nur für Moderatoren und Administratoren.
          </p>

          {error && (
            <div className="error-message" role="alert" style={{ marginBottom: 'var(--spacing-4)' }}>
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="ml-form" autoComplete="off">
            <div className="ml-field">
              <Label htmlFor="email">E-Mail</Label>
              <Input
                id="email"
                type="email"
                value={formData.email}
                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                autoComplete="off"
                required
                autoFocus
              />
            </div>
            <div className="ml-field">
              <Label htmlFor="password">Passwort</Label>
              <PasswordInput
                id="password"
                value={formData.password}
                onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                autoComplete="new-password"
                required
              />
            </div>
            <Button type="button" className="w-full" disabled={loading} onClick={handleButtonClick}>
              {loading ? 'Anmelden…' : (
                <>
                  Anmelden
                  <LogIn size={16} aria-hidden="true" style={{ marginLeft: '0.5rem' }} />
                </>
              )}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
